import type { Scene, SceneNodeId } from '../../scene/sceneState.js';
import type { AppState } from '../../state/appState.js';
import {
  addBlankInstance,
  addExistingComponentInstance,
  addFrameWithLayout,
  addLayerNode,
  deleteSelectedNode,
  type SceneTreeActionDeps,
} from './actions.js';
import { closePicker, showInstancePicker } from './instancePicker.js';

export function renderSceneTreeToolbar(
  parent: HTMLElement,
  activeContainerId: SceneNodeId | null,
  inComponentMode: boolean,
  appState: AppState,
  activeScene: Scene,
  actionDeps: SceneTreeActionDeps,
): void {
  const bar = document.createElement('div');
  bar.className = 'scene-tree-toolbar';

  const addRowBtn = document.createElement('button');
  addRowBtn.className = 'scene-tree-btn';
  addRowBtn.title = 'Add row';
  addRowBtn.textContent = '+ Row';
  addRowBtn.addEventListener('click', () => addFrameWithLayout(actionDeps, 'row'));
  bar.appendChild(addRowBtn);

  const addColBtn = document.createElement('button');
  addColBtn.className = 'scene-tree-btn';
  addColBtn.title = 'Add column';
  addColBtn.textContent = '+ Col';
  addColBtn.addEventListener('click', () => addFrameWithLayout(actionDeps, 'column'));
  bar.appendChild(addColBtn);

  const addStackBtn = document.createElement('button');
  addStackBtn.className = 'scene-tree-btn';
  addStackBtn.title = 'Add stack';
  addStackBtn.textContent = '+ Stack';
  addStackBtn.addEventListener('click', () => addFrameWithLayout(actionDeps, 'stack'));
  bar.appendChild(addStackBtn);

  const addFreeBtn = document.createElement('button');
  addFreeBtn.className = 'scene-tree-btn';
  addFreeBtn.title = 'Add free frame';
  addFreeBtn.textContent = '+ Free';
  addFreeBtn.addEventListener('click', () => addFrameWithLayout(actionDeps, null));
  bar.appendChild(addFreeBtn);

  const addLayerBtn = document.createElement('button');
  addLayerBtn.className = 'scene-tree-btn scene-tree-btn-icon';
  addLayerBtn.title = 'Add layer';
  addLayerBtn.textContent = '+ ●';
  addLayerBtn.addEventListener('click', () => addLayerNode(actionDeps));
  bar.appendChild(addLayerBtn);

  const addInstWrap = document.createElement('div');
  addInstWrap.style.position = 'relative';
  const addInstBtn = document.createElement('button');
  addInstBtn.className = 'scene-tree-btn';
  addInstBtn.title = inComponentMode ? 'Add component inside this component' : 'Add component';
  addInstBtn.textContent = '+ ◆';
  addInstBtn.addEventListener('click', (e) => {
    e.stopPropagation();
    const existing = document.querySelector('.scene-instance-picker');
    if (existing) { closePicker(); return; }
    showInstancePicker(addInstWrap, appState, {
      addBlankInstance: () => addBlankInstance(actionDeps),
      addExistingComponentInstance: componentId => addExistingComponentInstance(actionDeps, componentId),
    });
  });
  addInstWrap.appendChild(addInstBtn);
  bar.appendChild(addInstWrap);

  if (actionDeps.selection.getSelectedSceneNodeId()) {
    const delBtn = document.createElement('button');
    delBtn.className = 'scene-tree-btn scene-tree-btn-danger';
    delBtn.title = 'Delete';
    delBtn.textContent = '✕';
    delBtn.addEventListener('click', () => deleteSelectedNode(actionDeps));
    bar.appendChild(delBtn);
  }

  parent.appendChild(bar);

  if (activeContainerId) {
    const container = activeScene.nodes[activeContainerId];
    if (container?.kind === 'frame') {
      const meta = document.createElement('div');
      meta.className = 'scene-tree-toolbar-meta';
      meta.textContent = `Add to: ${container.name}${inComponentMode ? ' (component)' : ''}`;
      parent.appendChild(meta);
    }
  }
}
